import React from "react";

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";

import { ICircleIcon } from "./interface";
import { CircleIconDiv } from "./styles";

export const CircleIcon: React.FC<ICircleIcon> = ({
  icon,
  backgroundColor,
  borderColor,
  colorIcon,
  widthHeightBorder,
  widthHeightIcon,
}) => {
  function getIcon() {
    switch (icon) {
      case "avatar":
        return <PermIdentityIcon />;
      case "record":
        return <VideocamOutlinedIcon />;
      case "magnifier":
        return <SearchOutlinedIcon />;
      case "file":
        return <DescriptionOutlinedIcon />;
      case "video":
        return <OndemandVideoIcon />;
      default:
        return <h1>-</h1>;
    }
  }

  return (
    <CircleIconDiv
      borderColor={borderColor}
      backgroundColor={backgroundColor}
      colorIcon={colorIcon}
      widthHeightBorder={widthHeightBorder}
      widthHeightIcon={widthHeightIcon}
      data-testid="CircleIconDiv"
    >
      {getIcon()}
    </CircleIconDiv>
  );
};
